import { jsx as _jsx } from "react/jsx-runtime";
import { Container } from '@design-system/container';
import { Col, Grid, GridRow } from '@design-system/grid';
export const Layout = ({ children, pb = '120px' }) => (_jsx(Container, { height: "auto", pb: pb, children: _jsx(Grid, { height: "100%", mx: { _: 0, m: '32px' }, width: "100%", children: _jsx(GridRow, { children: _jsx(Col, { offset: {
                    xl: 2 / 12,
                    m: 1 / 12,
                }, pt: { _: 0, m: 6 }, width: {
                    xl: 8 / 12,
                    m: 10 / 12,
                }, children: children }) }) }) }));
//# sourceMappingURL=Layout.js.map